module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAsAQMAAACNPgDWAAAAA1BMVEX9fiiebyHbAAAAC0lEQVQI12MYBAAAAIQAAcTjexEAAAAASUVORK5CYII="